module.exports = __webpack_public_path__ + "static/the-ultimate-sales-machine-8d88438ae75d5ff2dc8a2a6970e6ed59.jpg";